import React from "react";
import { Modal, Segment, Header, Button, Grid } from "semantic-ui-react";

function ModalConfirm(props) {
  const handlePagoEfectivo = () =>
    props.handleFormaDePago({
      idInscripcion: props.idInscripcion,
      formaDePago: "efectivo"
    });

  const handlePagoTransferencia = () =>
    props.handleFormaDePago({
      idInscripcion: props.idInscripcion,
      formaDePago: "transferencia"
    });

  const handlePagoNoSeSabe = () =>
    props.handleFormaDePago({
      idInscripcion: props.idInscripcion,
      formaDePago: "desconocida"
    });

  return (
    <Modal open={props.open} size="tiny">
      <Modal.Header>
        <Header color="pink" content="¿Cómo ha pagado?" textAlign="center" />
      </Modal.Header>
      <Modal.Content scrolling>
        <Modal.Description>
          <Grid centered columns={3}>
            <Button
              inverted
              color="green"
              icon="money"
              content="Efectivo"
              onClick={handlePagoEfectivo}
            />
            <Button
              inverted
              color="blue"
              icon="credit card alternative"
              content="Transferencia"
              onClick={handlePagoTransferencia}
            />
            <Button
              inverted
              color="red"
              icon="minus circle"
              content="Desconocida"
              onClick={handlePagoNoSeSabe}
            />
          </Grid>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Segment basic>
          <Grid centered columns={3}>
            <Button
              inverted
              color="red"
              icon="frown"
              content="No quiero hacer nada"
              onClick={props.handleCancelarModal}
              size="large"
            />
          </Grid>
        </Segment>
      </Modal.Actions>
    </Modal>
  );
}

export default ModalConfirm;



// WEBPACK FOOTER //
// ./src/pages/shared/ModalConfirm.jsx